// import React from 'react';
// import styles from './UserManagement.module.css';

// const UserSearchBar = ({ searchTerm, onSearchChange }) => {
//     return (
//         <div className={styles.searchBar}>
//             <div className={styles.searchWrapper}>
//                 <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <circle cx="11" cy="11" r="8" />
//                     <path d="m21 21-4.35-4.35" />
//                 </svg>
//                 <input
//                     type="text"
//                     className={styles.searchInput}
//                     placeholder="Search by name, email, or contact..."
//                     value={searchTerm}
//                     onChange={onSearchChange}
//                 />
//             </div>
//             <div className={styles.actionButtons}>
//                 <button className={styles.actionButton}><span className={styles.actionIcon}>⚙</span>Customize</button>
//                 <button className={styles.actionButton}>Import</button>
//                 <button className={styles.actionButton}><span className={styles.actionIcon}>↓</span>Export</button>
//             </div>
//         </div>
//     );
// };

// export default UserSearchBar;

import React from 'react';
import styles from './UserManagement.module.css';

const UserSearchBar = ({ searchTerm, onSearchChange }) => {
    return (
        <div className={styles.searchBar}>
            <div className={styles.searchWrapper}>
                <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                </svg>
                <input
                    type="text"
                    className={styles.searchInput}
                    placeholder="Search by name, email, or contact..."
                    value={searchTerm}
                    onChange={onSearchChange}
                />
            </div>
            <div className={styles.actionButtons}>
                <button className={styles.actionButton}><span className={styles.actionIcon}>⚙</span>Customize</button>
                <button className={styles.actionButton}>Import</button>
                <button className={styles.actionButton}><span className={styles.actionIcon}>↓</span>Export</button>
            </div>
        </div>
    );
};

export default UserSearchBar;